import { HttpClient } from '@lib/HttpClient';
import { cookieLangName, getCookie } from '@root/src/cookie';
const language = getCookie(cookieLangName) || 'vn';

function normalizeAppearUrl(value: string) {
  const normalized = value.trim().replace(/\/+$/, '');
  if (normalized.includes('lytra.vn')) {
    return 'https://lytra.vn';
  }
  if (normalized.includes('tramhuongmocphucduyen.com')) {
    return 'https://tramhuongmocphucduyen.com';
  }
  return normalized;
}

function resolveAppear(appear?: string) {
  if (appear && appear !== 'undefined' && appear !== 'null') {
    return normalizeAppearUrl(appear);
  }
  if (process.env.NEXT_PUBLIC_APPEAR) {
    return normalizeAppearUrl(process.env.NEXT_PUBLIC_APPEAR);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeAppearUrl(window.location.origin);
  }
  return '';
}

export async function fetchProductByLinkChild(id, page) {
  const appear = resolveAppear();
  const appearParam = appear ? `&appear=${encodeURIComponent(appear)}` : '';
  const url = `/category/${id}?lang=${language}&page=${page}${appearParam}`;
  const response = await HttpClient.httpGet(url);
  return response.data.data[0];
}
const prefix = '/product';
export async function searchProduct(
  name: string,
  currentPage = 1,
  appear?: string
) {
  const appearValue = resolveAppear(appear);
  const appearParam = appearValue
    ? `&appear=${encodeURIComponent(appearValue)}`
    : '';
  return new Promise(resolve => {
    HttpClient.httpGet(
      `${prefix}/search?searchTerm=${name}&lang=${language}&currentPage=${currentPage}${appearParam}`
    )
      .then(res => {
        if (res.success) {
          return resolve(res);
        } else {
          return resolve([]);
        }
      })
      .catch(error => {
        console.error('Error searching for product:', error);
        return resolve([]);
      });
  });
}
export async function getProductBySlug(slug: string, lang, appear?: string) {
  try {
    const appearValue = resolveAppear(appear);
    const appearParam = appearValue
      ? `&appear=${encodeURIComponent(appearValue)}`
      : '';
    const data = await HttpClient.httpGet(
      `${prefix}/slug/${slug}?lang=${lang}${appearParam}`
    );

    return data;
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    return null;
  }
}
export async function getProductList(appear?: string, lang?: string) {
  const appearValue = resolveAppear(appear);
  const appearParam = appearValue
    ? `&appear=${encodeURIComponent(appearValue)}`
    : '';
  const langValue = lang || language;

  const endpoint = `/product?lang=${langValue}${appearParam}`;
  try {
    const data = await HttpClient.httpGet(endpoint);
    return data;
  } catch (error) {
    return null;
  }
}
export async function getProductRecommendation(data, appear?: string) {
  const params: any = {};

  if (data.weight !== null && data.weight !== undefined && data.weight !== '') {
    params.weight = Number(data.weight);
  }
  if (data.height !== null && data.height !== undefined && data.height !== '') {
    params.height = Number(data.height);
  }
  if (
    data.wristSize !== null &&
    data.wristSize !== undefined &&
    data.wristSize !== ''
  ) {
    params.wrist = Number(data.wristSize);
  }
  if (data.gender !== null && data.gender !== undefined && data.gender !== '') {
    params.gender = Number(data.gender);
  }
  const appearValue = resolveAppear(appear);
  if (appearValue) {
    params.appear = appearValue;
  }

  // Construct query string dynamically
  const queryString = new URLSearchParams(params).toString();
  const endpoint = `/product/get-productrecommend${queryString ? `?${queryString}` : ''}`;
  try {
    const response = await HttpClient.httpGet(endpoint);
    return response;
  } catch (error) {
    return null;
  }
}
